export default __webpack_public_path__ + "static/media/ellipsis-v.f114055b.svg";